import { combineReducers } from 'redux'
import { CommonState, CommonReducer } from './common/common.reducer'
import { TopicState, TopicReducer } from './topic/topic.reducer'

export interface ApiError {
  [key: string]: Response | Error | Record<string, unknown> | undefined
}

export interface TopicRootState {
  commonStore: CommonState
  topicStore: TopicState
}

export const topicRootReducer = combineReducers<TopicRootState>({
  commonStore: CommonReducer,
  topicStore: TopicReducer,
})
